import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {ForYouDisplayActions} from "../types/ForYouDisplayActions";
import {ForYouEventType} from "../types/ForYouEventType";
import {ForYouOpenType} from "../types/ForYouOpenType";
import {getOpenFromLeadString, getOpenFromSimpleString} from "../utils/get_open_from_string";

interface IForYouDisplayEvent {
    event: ForYouEventType;
    action: ForYouDisplayActions;
    region: string;
    openFrom?: ForYouOpenType;
}

export const ForYouFormDisplayGtmEvent = (payload: IForYouDisplayEvent) => {
    const customLabel = getOpenFromSimpleString(payload.openFrom);
    const data = {
        event: payload.event,
        event_action: payload.action,
        event_category: payload.region,
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(data);
};

interface IForYouMapCheckboxEvent {
    mainRegionName: string;
    regionName: string;
    checked: boolean;
    openFrom?: ForYouOpenType;
}

export const ForYouRegionChangeGtmEvent = (payload: IForYouMapCheckboxEvent) => {
    const customLabel = getOpenFromSimpleString(payload.openFrom);
    const data = {
        event: ForYouEventType.REGION,
        event_action: "checkbox",
        event_category: payload.mainRegionName,
        event_category2: payload.regionName,
        event_label: payload.checked ? "on" : "off",
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(data);
};

interface IForYouCriteriaGtmPayload {
    rooms: string;
    area: string;
    budget: string;
    instalment: string;
    openFrom?: ForYouOpenType;
}

export const ForYouCriteriaGtmEvent = (payload: IForYouCriteriaGtmPayload) => {
    const customLabel = getOpenFromSimpleString(payload.openFrom);
    const data = {
        event: ForYouEventType.CRITERIA,
        event_action: ForYouDisplayActions.APPLY,
        event_label: payload.rooms,
        event_category: payload.area,
        event_category2: payload.budget,
        event_category3: payload.instalment,
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(data);
};

export const ForYouSendGtmEvent = (openFrom?: ForYouOpenType) => {
    hitGoogleTagManager({
        event: ForYouEventType.USER,
        event_action: "apply",
        value: 1,
        lead_source: getOpenFromLeadString(openFrom)
    });
};

interface IForYouAdditionalGtmPayload {
    additionalAreas: string;
    kitchenType: string;
    floor: string;
    quarters: string;
    date: string;
    message: string;
    openFrom?: ForYouOpenType;
}

export const ForYouAdditionalGtmEvent = (payload: IForYouAdditionalGtmPayload) => {
    const customLabel = getOpenFromSimpleString(payload.openFrom);
    const data = {
        event: ForYouEventType.ADDITIONAL,
        event_action: ForYouDisplayActions.APPLY,
        event_label: payload.additionalAreas,
        event_category: payload.kitchenType,
        event_category2: payload.floor,
        event_category3: payload.quarters,
        event_category4: payload.date,
        event_category5: payload.message,
        ...(customLabel ? {custom_label: customLabel} : {})
    };
    hitGoogleTagManager(data);
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {ForYouDisplayActions} from "../types/ForYouDisplayActions";
import {ForYouEventType} from "../types/ForYouEventType";
import {ForYouOpenType} from "../types/ForYouOpenType";
import {getOpenFromLeadString, getOpenFromSimpleString} from "../utils/get_open_from_string";

interface IForYouDisplayEvent {
    event: ForYouEventType;
    action: ForYouDisplayActions;
    region: string;
    openFrom?: ForYouOpenType;
}

export const ForYouFormDisplayGtmEvent = (payload: IForYouDisplayEvent) => {
    const customLabel = getOpenFromSimpleString(payload.openFrom);
    const data = {
        event: payload.event,
        event_action: payload.action,
        event_category: payload.region,
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(data);
};

interface IForYouMapCheckboxEvent {
    mainRegionName: string;
    regionName: string;
    checked: boolean;
    openFrom?: ForYouOpenType;
}

export const ForYouRegionChangeGtmEvent = (payload: IForYouMapCheckboxEvent) => {
    const customLabel = getOpenFromSimpleString(payload.openFrom);
    const data = {
        event: ForYouEventType.REGION,
        event_action: "checkbox",
        event_category: payload.mainRegionName,
        event_category2: payload.regionName,
        event_label: payload.checked ? "on" : "off",
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(data);
};

interface IForYouCriteriaGtmPayload {
    rooms: string;
    area: string;
    budget: string;
    instalment: string;
    openFrom?: ForYouOpenType;
}

export const ForYouCriteriaGtmEvent = (payload: IForYouCriteriaGtmPayload) => {
    const customLabel = getOpenFromSimpleString(payload.openFrom);
    const data = {
        event: ForYouEventType.CRITERIA,
        event_action: ForYouDisplayActions.APPLY,
        event_label: payload.rooms,
        event_category: payload.area,
        event_category2: payload.budget,
        event_category3: payload.instalment,
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(data);
};

export const ForYouSendGtmEvent = (openFrom?: ForYouOpenType) => {
    hitGoogleTagManager({
        event: ForYouEventType.USER,
        event_action: "apply",
        value: 1,
        lead_source: getOpenFromLeadString(openFrom)
    });
};

interface IForYouAdditionalGtmPayload {
    additionalAreas: string;
    kitchenType: string;
    floor: string;
    quarters: string;
    date: string;
    message: string;
    openFrom?: ForYouOpenType;
}

export const ForYouAdditionalGtmEvent = (payload: IForYouAdditionalGtmPayload) => {
    const customLabel = getOpenFromSimpleString(payload.openFrom);
    const data = {
        event: ForYouEventType.ADDITIONAL,
        event_action: ForYouDisplayActions.APPLY,
        event_label: payload.additionalAreas,
        event_category: payload.kitchenType,
        event_category2: payload.floor,
        event_category3: payload.quarters,
        event_category4: payload.date,
        event_category5: payload.message,
        ...(customLabel ? {custom_label: customLabel} : {})
    };
    hitGoogleTagManager(data);
};
